
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

const ONE_MB = 1024 * 1024;

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fileSize(): string {
      const size = this.file.size / ONE_MB;
      return `${size.toFixed(2)} MB`;
    },
  },
});
